






















































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {debounce} from "lodash";
import PPTeProxy from "@/utils/ppt";

@Component({
  name: "Controller",
})
export default class Controller extends Vue {
  @Prop() readonly frame!: HTMLIFrameElement;
  @Prop() readonly current!: number;
  @Prop() readonly images!: Array<string>;
  @Prop() readonly extendPanelStatus!: boolean;
  @Prop({ default: false }) readonly isMobile!: boolean;
  // private slideSwiper?: SwiperClass;
  private frameWindow: Window | null = null;
  private frameSize = {
    width: 0,
    height: 0,
  };
  private status = false;
  private slideTotal = 0;
  private slideCurrentIndex = 0;
  private fullscreenStatus = false;
  private disabled = {
    prev: false,
    next: false,
  };
  private thumbs: any[] = [];
  private isThumbsShow = false;
  private previewWidth = 116;
  private previewHeight = 64;

  @Watch("frame")
  onFrameLoad() {
    this.frame.onload = () => {
      PPTeProxy.target = null;
      this.init();
    };
  }
  @Watch("slideTotal")
  onSlideTotal() {
    this.$emit("sigTotal", this.slideTotal);
  }
  @Watch("extendPanelStatus")
  onExtendPanelStatus(val: boolean) {
    if (PPTeProxy && PPTeProxy.preview) {
      PPTeProxy.preview.toggleThumbs(val);
    }
  }

  @Watch("current")
  onFrameCurrentChange() {
    this.updateSlideCtrlData();
  }

  handleThumbsVisibleToggle() {
    const { isThumbsShow } = this;
    this.isThumbsShow = !isThumbsShow;
    if (PPTeProxy && PPTeProxy.preview) {
      if (this.isThumbsShow) {
        PPTeProxy.preview.showPreviewThumbs();
      } else {
        PPTeProxy.preview.hidePreviewThumbs();
      }
    }
  }

  handleThumbsSlideTo(index: number) {
    if (PPTeProxy && PPTeProxy.preview) {
      PPTeProxy.preview.slideToThumb(index);
    }
  }

  handleFullscreenClick(): void {
    const document: any = window.document;
    const docEl: any = document.documentElement;
    if (this.fullscreenStatus) {
      if (document.exitFullscreen && document.fullscreenEnabled) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen && document.msFullScreenEnabled) {
        document.msExitFullscreen();
      } else if (
        document.mozCancelFullScreen &&
        document.mozFullScreenEnabled
      ) {
        document.mozCancelFullScreen();
      } else if (
        document.webkitExitFullscreen &&
        document.webkitFullscreenEnabled
      ) {
        document.webkitExitFullscreen();
      }
    } else {
      if (docEl.requestFullscreen && document.fullscreenEnabled) {
        docEl.requestFullscreen();
      } else if (docEl.mozRequestFullScreen && document.mozFullScreenEnabled) {
        docEl.mozRequestFullScreen();
      } else if (docEl.msRequestFullscreen && document.msFullScreenEnabled) {
        docEl.msRequestFullscreen();
      } else if (
        docEl.webkitRequestFullscreen &&
        document.webkitFullscreenEnabled
      ) {
        docEl.webkitRequestFullScreen();
      }
    }
  }

  handleThumbsItemClick(index: number): void {
    PPTeProxy.GotoStep(index);
  }

  handlePrevBtnClick(): void {
    if (this.disabled.prev) return;
    PPTeProxy.PrevStep();
    // this.updateSlideCtrlData();
  }

  handleNextBtnClick(): void {
    if (this.disabled.next) return;
    PPTeProxy.NextStep();
    // this.updateSlideCtrlData();
  }

  getCol(value: number, num = 0): number {
    return Math.floor(value / 10) + num;
  }

  getFrameWindow(): Window | null {
    const $frame = this.frame;
    if (!$frame) {
      return null;
    }
    return $frame.contentWindow;
  }

  setFrameSize(): void {
    if (!PPTeProxy.target) {
      return;
    }
    this.frameSize = PPTeProxy.GetSlideSize();
    this.frame.style.width = this.frameSize.width + "px";
    this.frame.style.height = this.frameSize.height + "px";
  }

  handleFrameResize(): void {
    const { width, height } = this.frameSize;
    const { innerWidth, innerHeight } = window;
    const style = {
      width: "100%",
      height: "100%",
    };
    if (innerWidth > innerHeight) {
      style.height = innerHeight + "px";
      style.width = (width * innerHeight) / innerWidth + "px";
    } else {
      style.width = innerWidth + "px";
      style.height = (height * innerWidth) / innerHeight + "px";
    }
    this.frame.style.width = style.width;
    this.frame.style.height = style.height;
  }

  // onSwiper(swiper: SwiperClass): void {
  //   if (swiper) {
  //     this.slideSwiper = swiper;
  //   }
  // }

  updateSlideCtrlData(): void {
    this.slideTotal = PPTeProxy.GetSlideCount() || this.images.length;
    this.slideCurrentIndex = PPTeProxy.GetCurrentIndex();
    this.disabled.prev = this.slideCurrentIndex === 0;
    this.disabled.next = this.slideCurrentIndex >= this.slideTotal - 1;

    // if (this.slideSwiper && this.isThumbsShow) {
    //   this.slideSwiper.slideTo(this.slideCurrentIndex);
    // }
    this.handleThumbsSlideTo(this.slideCurrentIndex);
  }

  waitTimeout(time: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  initPPTFrame(): void {
    this.frameWindow = this.getFrameWindow();
  }

  async initPPTFrameLoop(): Promise<any> {
    if (!this.frameWindow) {
      await this.waitTimeout(500);
      this.initPPTFrame();
      return await this.initPPTFrameLoop();
    } else {
      return this.frameWindow;
    }
  }

  initPPTProxy(): void {
    // console.log(this.frameWindow)
    PPTeProxy.target = (this.frameWindow as any).PPTe;
    PPTeProxy.preview = (this.frameWindow as any).Preview;
  }

  async initPPTProxyLoop(): Promise<any> {
    if (!PPTeProxy.target) {
      await this.waitTimeout(500);
      this.initPPTProxy();
      return await this.initPPTProxyLoop();
    } else {
      return PPTeProxy.target;
    }
  }

  async waitFrameLoaded(): Promise<void> {
    await this.initPPTFrameLoop();
    await this.initPPTProxyLoop();
  }

  initToolsSizeAndStatus(): void {
    try {
      this.$emit("showTools", this.status);
      this.$emit("canvasSize", PPTeProxy.GetSlideSize());
    } catch (e) {
      setTimeout(() => {
        this.initToolsSizeAndStatus();
      }, 1000);
    }
  }

  init(): void {
    this.waitFrameLoaded().then(() => {
      this.updateSlideCtrlData();
      this.status = true;
      this.initToolsSizeAndStatus();
      window.addEventListener(
        "resize",
        debounce(() => {
          this.$emit("canvasSize", PPTeProxy.GetSlideSize());
          this.$emit("screenSize", window.innerWidth, window.innerHeight);
          if (this.fullscreenStatus !== document.fullscreen) {
            this.fullscreenStatus = document.fullscreen;
          }
        }, 1000)
      );
      window.addEventListener("fullscreenchange", () => {
        this.fullscreenStatus = document.fullscreen;
        setTimeout(() => {
          this.$emit("screenSize", window.innerWidth, window.innerHeight);
        }, 1000);
      });
      window.addEventListener("keydown", (e) => {
        switch (e.keyCode) {
          case 38:
          case 37:
          case 33:
            this.handlePrevBtnClick();
            break;
          case 40:
          case 39:
          case 32:
          case 34:
            this.handleNextBtnClick();
            break;
          case 122:
            e.preventDefault();
            this.handleFullscreenClick();
            break;
          default:
            break;
        }
      });
      this.frame.contentWindow?.addEventListener("keydown", (e) => {
        if (e.keyCode === 122) {
          e.preventDefault();
          this.handleFullscreenClick();
        }
      });
    });
  }
}
